const isNoValue = (value) =>
  void 1 === value ||
  null === value ||
  '' === value ||
  'symbol' === typeof value ||
  Number.isNaN(value) ||
  Infinity === value ||
  -Infinity === value;

// noinspection JSUnusedGlobalSymbols
export default isNoValue;
